module.exports = __webpack_public_path__ + "media/zebra_k.b2b6b713.mp3";